import { createAxiosClient } from '@/utils/axios/createAxiosClient';
import getEnv from '@/env';

export const DealsDashboardClient = createAxiosClient({
  options: {
    baseURL: getEnv().deals_dashboard_service_url,
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 300000,
  },
});
